import axios from "../api";
/**
 * Current credit balance plus the live price of every metered feature. The cost
 * returned here is the exact amount a qualifying call debits, so it can be
 * shown to the user verbatim.
 */
export const getCredits = async () => {
    const { data } = await axios.get("/credits");
    return data;
};
export default getCredits;
//# sourceMappingURL=getCredits.js.map